import { useAuthStore } from '@/stores/auth'
import { useUserProfileStore } from '@/stores/userProfile'

/**
 * Resolves the current user's organization ID.
 *
 * Prefers `userProfileStore.profile.organizationId` (populated from `/api/users/me`,
 * authoritative) and falls back to `authStore.user.organizationId` (populated from
 * the Firebase custom claim, which may lag after page refresh, backend deploy, or
 * a first-login race — see issue #2172).
 *
 * Throws when neither source has an org ID. The caller should treat this as an
 * unrecoverable error for the current operation.
 */
export function getCurrentOrganizationId(): string {
  const orgId =
    useUserProfileStore().profile?.organizationId
    ?? useAuthStore().user?.organizationId
  if (!orgId) {
    throw new Error('No organization ID available')
  }
  return orgId
}
